// data keys for chart and data processing
export const DATAKEY_USER_ACTIVATION = "userActivation";
export const DATAKEY_MERKEN_IMPRESSIONS = "merkenImpressions";
export const DATAKEY_MERKEN_CLICKS_BY_VARIANT = "merkenClicksByVariant";
export const DATAKEY_MERKEN_TOTAL_IMPRESSIONS = "merkenTotalImpressions";
export const DATAKEY_MERKEN_TOTAL_CLICKS = "merkenTotalClicks";
export const DATAKEY_MERKEN_CTR = "merkenCTR";
export const DATAKEY_PLUGIT_DOCK = "plugitDock";
export const DATAKEY_TOOLTIP = "tooltip";
export const DATAKEY_WIZARD = "wizard";

// percentage data keys
export const DATAKEY_PLUGIT_DOCK_PERCENT = "plugitDockPercent";
export const DATAKEY_TOOLTIP_PERCENT = "tooltipPercent";
export const DATAKEY_WIZARD_PERCENT = "wizardPercent";

// category mapping for normalization
export const CATEGORY_MAPPINGS = {
  PLUGIT_DOCK: DATAKEY_PLUGIT_DOCK,
  TOOLTIP: DATAKEY_TOOLTIP,
  WIZARD: DATAKEY_WIZARD,
};

// all category data keys
export const CATEGORY_DATA_KEYS = [
  DATAKEY_PLUGIT_DOCK,
  DATAKEY_TOOLTIP,
  DATAKEY_WIZARD,
];

// tooltip + Wizard combined for User Activation report
export const DATAKEY_ONBOARDING_TOOLTIP_WIZARD = "onboardingTooltipWizard";

// report indices
export const REPORT_INDEX_ACTIVATION = 0;
export const REPORT_INDEX_USER_SIGNUP = 1;
export const REPORT_INDEX_TOOLTIP_OPEN = 2;
export const REPORT_INDEX_MERKEN_CLICKS = 3;
export const REPORT_INDEX_MERKEN_IMPRESSIONS = 4;
export const REPORT_INDEX_MERKEN_CLICKS_BY_VARIANT = 5;

export const DATAKEY_TOOLTIP_OPEN = "tooltipOpen";
export const DATAKEY_TOTAL_ACTIVATION = "totalActivation";
export const DATAKEY_CONVERSION_RATE = "conversionRate";

export const DATAKEY_USER_SIGNUP = "userSignup";
// signup / tooltip open
export const DATAKEY_SIGNUP_RATE = "signupRate";

// wizard drop-off report
export const REPORT_INDEX_WIZARD_STEP_IMPRESSIONS = 6;
export const REPORT_INDEX_WIZARD_DISMISSALS = 7;
export const REPORT_INDEX_WIZARD_REGISTER_CLICKS = 8;

export const DATAKEY_WIZARD_IMPRESSIONS = "wizardImpressions";
export const DATAKEY_WIZARD_DISMISSALS = "wizardDismissals";
export const DATAKEY_WIZARD_DISMISS_RATE = "wizardDismissRate";
export const DATAKEY_WIZARD_REGISTER_CLICKS = "wizardRegisterClicks";
